import React, { Component } from "react";
import { withRouter } from "react-router";
import AppBar from "../components/AppBar";
import { Toast } from "../utils/sweetalert";
import withReactContent from "sweetalert2-react-content";
import { setLoginUser, setSignout, setSignupUser } from "../redux/actions/usersActions";
import { getUserToken } from "../redux/reducers";
import { connect } from "react-redux";
import LoginUser from "../components/LoginUser";
import api from "../utils/axiosApi";
import jwtDecode from "jwt-decode";
import { withTranslation } from "react-i18next";
import queryString from "query-string";
import InputsCopyModel from "../components/InputsCopyModel";
import moment from "moment";
import Routes from "../utils/Routes";
import PaymentGatewayService from "../utils/Payment";

//import { getRandomColor } from '../utils/getRandomColor';
class CopyModelAgency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showCitiesPop: false,
      showQrPop: false,
      showSearchMobile: false,
      signUp: false,
    };
    this.handleCopyModelAgency = this.handleCopyModelAgency.bind(this);
    this.handleBuyModel = this.handleBuyModel.bind(this);
  }
  componentDidMount() {
    document.title = "Tripendar";
  }
  handleCopyModelAgency = async (data) => {
    const { t, history } = this.props;

    if (!data.start) {
      return;
    }

    const { search } = history.location;

    const values = queryString.parse(search);
    let id = "";
    const {data:response_data, error} = await api.get(
      `/agencias/getAgency/${this.props.match.params.idAgency}`
    );
    if (error) throw new Error(error);

    const agency = response_data.data


    const data_user =  {
      name: data?.name || "",
      lastName: data?.lastName || "",
      email: data?.email || "",
      telephone: data?.telephone || "",
      DNI: data?.DNI || "",
      dateBirth: data?.dateBirth?.replace(/-/g, "/") || "",
      nationality: data?.nationality || "",
      direction: data?.direction || "",
      numberUsers: data?.numberUsers || 1,
    }
    let user = undefined 
    if (this.props.token) {
      const decUser = jwtDecode(this.props.token);
      user = decUser.user;
    }
    
    if (values.model) {
      this.handleBuyModel(values.model, agency, user, data.start, data_user);
    } else {
      const calendar = {
        name: t("myCalendar"),
        city: undefined,
        startDate: moment(data.start, "YYYY-MM-DD").toDate(),
        minDate: moment(data.start, "YYYY-MM-DD").subtract(1, "day").toDate(),
        maxDate: moment(data.start, "YYYY-MM-DD").add(2, "years").toDate(),
        startAtTime: 6,
        agendaItems: [],
        agency: agency?._id,
        toDolist: [],
        inv: [],
        dataUser: data_user,
      };
      try {
        let users = [];
        if (user) {
          users = [user];
        }
        const calendarUser = { ...calendar, users: users };
        const resp = await api.post(`/agencyCalendar/set`, calendarUser);
        id = resp.data.data._id;
      } catch (error) {
        console.log(error);
      }
    }
    if (id)
      this.props.history.push(
        Routes.agencyCalendar(this.props.match?.params?.idAgency, id)
      );
  };

  handleBuyModel = async (model_id, agency, user, startDate, extra_data) => {
    const users = []
    const {data:response_data, error} = await api.get(`/ModelsCalendar/getbyid/${model_id}`)
    if (error) throw new Error(error);

    const model = response_data.data
    if (user)
      users.push(user._id)
    
      if (model.cost>0) {
        const tax_percentage = 0.19;
        const tax = model.cost * tax_percentage;
        const tax_base = model.cost - tax;
        var data_to_send = {
          //Parametros compra (obligatorio)
          name: model.name,
          description: `Calendario de "${agency.legalNameAgency}"`,
          // invoice: "FAC-1234",
          currency: `${model.currency}`,
          amount: `${model.cost}`,
          tax_base: `${tax_base}`,
          tax: "0",
          tax_ico: `${tax}`,
          country: "co",
          lang: "en",
  
          //Onpage="false" - Standard="true"
          external: "false",
  
          //Atributos opcionales
          // extra1: "extra1",
          payerId: user?._id,
          receiverId: agency.userId,
          calendar_data: {
              model: model,
              startDate: startDate.replace(/-/g, "/"),
              users,
              extra_data,
          },
  
          //Atributos cliente
          // name_billing: "Jhon Doe",
          // address_billing: "Carrera 19 numero 14 91",
          // type_doc_billing: "cc",
          // mobilephone_billing: "3050000000",
          // number_doc_billing: "100000000",
          // email_billing: "jhondoe@epayco.com",
  
          //atributo deshabilitación método de pago
          // methodsDisable: ["TDC", "PSE","SP","CASH","DP"]
        };
        PaymentGatewayService.open_model_payment(data_to_send);
      } else {
        const dataToSend = {
          external_id: "",
          resource_id: model._id,
          cost: model.cost,
          currency: model.currency,
          data: {
            modelId: model._id,
            startDate: startDate.replace(/-/g, "/"),
            users,
          },
          type: "model_itinerary",
          payer: user?._id,
          payer_email: user?.email ?? extra_data?.email,
          receiver: agency.userId,
          extra_data
        };
        const { data: payment } = await api.post("/payments", dataToSend);
        this.props.history.push(Routes.processPayment(payment.data.token));
      }
  };
  handleLoginCustomer = async (data) => {
    try {
      /*const MyToast = withReactContent(Toast)*/
      const respo = await this.props.setLoginUser(data);
      if (this.props.token !== "") {
        return true;
      } else {
        return respo;
      }
    } catch (error) {
      console.log(error);
    }
  };
  handleSignUpCustomer = async (data) => {
    try {
      const { t, i18n } = this.props;
      const MyToast = withReactContent(Toast);
      let respSignUp;
      if (data.accept) {
        respSignUp = await this.props.setSignupUser({
          payload: data,
          len: i18n.language,
        });
      }
      if (respSignUp && respSignUp.email) {
        await MyToast.fire({
          title: (
            <p style={{ fontSize: "22px", zIndex: 30000 }}>
              {t("registeredMail")}
            </p>
          ),
          icon: "error",
        });
      } else if (this.props.token !== "") {
        return;
      } else {
        await MyToast.fire({
          title: (
            <p style={{ fontSize: "22px", zIndex: 30000 }}>{t("errorToast")}</p>
          ),
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div
        className="bckColor"
        style={{
          height: "100vh",
          width: "100vw",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          className="principalBackground setPadding"
          style={{ justifyContent: "start", alignItems: "start" }}
        >
          <AppBar
            disableSearchBar
            istoken={this.props.token}
            oncitiesPop={() => {
              this.setState({
                showCitiesPop: true,
              });
            }}
            showMobileSearch={this.state.showSearchMobile}
            setShowMobile={(a) => {
              this.setState({ showSearchMobile: a });
            }}
            onCreateZeroCalendar={this.handleCopyModelAgency}
            onSignOut={this.props.setSignout}
            showSignUp={this.state.show}
            onClose={() => {
              this.setState({
                show: false,
                signUp: false,
              });
            }}
            onRegister={() => {
              this.setState({
                show: true,
                signUp: true,
              });
            }}
            onLogin={() => {
              this.setState({ show: true, signUp: false });
            }}
          ></AppBar>
          <InputsCopyModel
            onSubmit={this.handleCopyModelAgency}
          ></InputsCopyModel>
          {this.state.show && (
            <LoginUser
              signUp={this.state.signUp}
              onLogin={this.handleLoginCustomer}
              onSignUp={this.handleSignUpCustomer}
              onClose={() => {
                this.setState({
                  show: false,
                  signUp: false,
                });
              }}
            />
          )}
          {/* <Button className='doubtBtn' onClick={this.handleDoubt}>{t('iHaveDoubt')}
                </Button> */}
        </div>
      </div>
    );
  }
}
/*
<LandingBack></LandingBack>

*/

const mapStateToProps = (state) => {
  return {
    token: getUserToken(state),
  };
};
const mapDispatchToProps = (dispatch) => ({
  setLoginUser: (value) => dispatch(setLoginUser(value)),
  setSignupUser: (value) => dispatch(setSignupUser(value)),
  setSignout: (value) => dispatch(setSignout(value)),
});

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CopyModelAgency))
);
